var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeSubNav,
          expression: "closeSubNav",
        },
      ],
      staticClass: "navigation-main",
      attrs: { "aria-label": "Main navigation" },
    },
    [
      _c(
        "ul",
        { staticClass: "navigation-main__list" },
        _vm._l(_vm.navigation, function (menuItem, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "navigation-main__item",
              class: {
                "is-active": menuItem.active,
                "navigation-main__item--open": index == _vm.menuItemIndex,
                "navigation-main__item--close": _vm.isClosed,
              },
            },
            [
              menuItem.items.length > 0
                ? _c(
                    "button",
                    {
                      staticClass: "navigation-main__button",
                      attrs: { type: "button", title: menuItem.name },
                      on: {
                        click: function ($event) {
                          return _vm.showSubItems(
                            menuItem.items,
                            index,
                            menuItem.params
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(menuItem.name) +
                          "\n            "
                      ),
                    ]
                  )
                : _c(
                    "a",
                    {
                      staticClass: "navigation-main__button",
                      attrs: { href: menuItem.link },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(menuItem.name) +
                          "\n            "
                      ),
                    ]
                  ),
              _vm._v(" "),
              _vm.subMenuItems.length
                ? _c(
                    "div",
                    {
                      staticClass: "navigation-main__sublist-container",
                      class: {
                        "navigation-main__sublist-container--right":
                          _vm.position.right,
                        "navigation-main__sublist-container--left":
                          _vm.position.left,
                      },
                    },
                    [
                      _c(
                        "ul",
                        {
                          staticClass:
                            "navigation-main__sublist navigation-main__sublist--second",
                        },
                        _vm._l(_vm.subMenuItems, function (subItem, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              staticClass: "navigation-main__subitem",
                              class: { "is-subitem-active": subItem.active },
                            },
                            [
                              subItem.items.length
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "navigation-main__subbutton",
                                      class: {
                                        "navigation-main__subbutton--active":
                                          _vm.activeSubButton === index,
                                      },
                                      attrs: {
                                        type: "button",
                                        href: "#",
                                        title: subItem.name,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showSubItemsThirdLevel(
                                            subItem.items,
                                            index,
                                            subItem.name
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(subItem.name) +
                                          "\n                            "
                                      ),
                                      _c("img", {
                                        staticClass:
                                          "navigation-main__subbutton-icon",
                                        attrs: {
                                          src: "/images/arrow_bold.svg",
                                          width: "12",
                                          height: "12",
                                        },
                                      }),
                                    ]
                                  )
                                : _c(
                                    "a",
                                    {
                                      staticClass: "navigation-main__subbutton",
                                      attrs: {
                                        href: subItem.link,
                                        title: subItem.name,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(subItem.name) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "navigation-main__sublist__content-container",
                        },
                        [
                          _vm.subItemsThirdLevel.length
                            ? _c("div", [
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "navigation-main__sublist__content-title",
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.currentSubNavTitle) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "navigation-main__sublist navigation-main__sublist--third",
                                  },
                                  _vm._l(
                                    _vm.subItemsThirdLevel,
                                    function (item, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                          staticClass:
                                            "navigation-main__subitem",
                                          class: { "is-active": item.active },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "navigation-main__subbutton navigation-main__subbutton--third",
                                              class: {
                                                "is-active": item.active,
                                              },
                                              attrs: {
                                                href: item.link,
                                                title: item.name,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.name) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : [
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "navigation-main__sublist__content__description-title",
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.currentSubMenuContent
                                            .SUBMENU__TITLE
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("figure", [
                                  _vm.currentSubMenuContent.SUBMENU__IMG
                                    ? _c("img", {
                                        staticClass:
                                          "navigation-main__sublist__content__description-img",
                                        attrs: {
                                          src: _vm.currentSubMenuContent
                                            .SUBMENU__IMG,
                                          alt: "",
                                        },
                                      })
                                    : _c("img", {
                                        staticClass:
                                          "navigation-main__sublist__content__description-img",
                                        attrs: {
                                          src: "/images/dummy-main-nav.jpg",
                                          alt: "",
                                        },
                                      }),
                                  _vm._v(" "),
                                  _vm.currentSubMenuContent.SUBMENU__TEXT
                                    ? _c(
                                        "figcaption",
                                        {
                                          staticClass:
                                            "navigation-main__sublist__content__description-info",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.currentSubMenuContent
                                                  .SUBMENU__TEXT
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ],
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "navigation-main__sublist__content-button",
                              attrs: { type: "button" },
                              on: { click: _vm.closeSubNav },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "navigation-main__sublist__content-icon",
                                  attrs: {
                                    width: "32",
                                    height: "32",
                                    viewBox: "0 0 32 32",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("circle", {
                                    attrs: {
                                      cx: "26",
                                      cy: "26",
                                      r: "13",
                                      fill: "#F7F7F9",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      id: "line-first",
                                      "fill-rule": "evenodd",
                                      "clip-rule": "evenodd",
                                      d: "M11.4037 11.4038C11.7943 11.0133 12.4274 11.0133 12.8179 11.4038L20.5961 19.182C20.9866 19.5725 20.9866 20.2057 20.5961 20.5962C20.2056 20.9867 19.5724 20.9867 19.1819 20.5962L11.4037 12.818C11.0132 12.4275 11.0132 11.7943 11.4037 11.4038Z",
                                      fill: "#0B2C62",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      id: "line-second",
                                      "fill-rule": "evenodd",
                                      "clip-rule": "evenodd",
                                      d: "M20.5961 11.4038C20.9866 11.7943 20.9866 12.4275 20.5961 12.818L12.8179 20.5962C12.4274 20.9867 11.7943 20.9867 11.4037 20.5962C11.0132 20.2057 11.0132 19.5725 11.4037 19.182L19.1819 11.4038C19.5724 11.0133 20.2056 11.0133 20.5961 11.4038Z",
                                      fill: "#0B2C62",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }